/**
 * Credential status fixture for Settings › Collectors.
 * All timestamps derive from FROZEN_NOW.
 */

import { FROZEN_NOW_MS } from '@/lib/frozenTime';

export interface CredentialStatus {
  source: string;
  exists: boolean;
  lastUsedAt: string | null;
  lastFailedAt: string | null;
  lastFailureReason: string | null;
  lastRotatedAt: string | null;
  keyVersion: number | null;
}

const MINUTE_MS = 60 * 1000;
const DAY_MS = 24 * 60 * MINUTE_MS;

export const CREDENTIAL_STATUS: CredentialStatus = {
  source: 'insightful',
  exists: true,
  lastUsedAt: new Date(FROZEN_NOW_MS - 15 * MINUTE_MS).toISOString(),
  lastFailedAt: null,
  lastFailureReason: null,
  lastRotatedAt: new Date(FROZEN_NOW_MS - 30 * DAY_MS).toISOString(),
  keyVersion: 1,
};
